// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseListResourceMessage } from './genericApiResponseListResourceMessage';
import type { GenericApiResponseListResourcePagination } from './genericApiResponseListResourcePagination';
import type { GenericApiResponseListResourceData } from './genericApiResponseListResourceData';

export interface GenericApiResponseListResource {
  success?: boolean;
  message?: GenericApiResponseListResourceMessage;
  pagination?: GenericApiResponseListResourcePagination;
  data?: GenericApiResponseListResourceData;
}
